// import React, { createContext, useContext, useEffect, useState } from 'react';
// import { supabase } from '../shared/supabaseclient';

// const AppContext = createContext();

// export const AppProvider = ({ children }) => {
//   const [trucks, setTrucks] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     fetchTrucks();
//   }, []); 

//   const fetchTrucks = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const { data, error: supabaseError } = await supabase
//         .from('trucks')
//         .select('*')
//         .order('created_at', { ascending: false });

//       if (supabaseError) {
//         console.error('Supabase error:', supabaseError);
//         throw new Error(supabaseError.message || 'Failed to fetch trucks');
//       }

//       if (data) {
//         console.log('Fetched trucks:', data);
//         setTrucks(data);
//       }
//     } catch (err) {
//       console.error('Error fetching trucks:', err);
//       setError(err instanceof Error ? err.message : 'An unexpected error occurred');
//     } finally {
//       setLoading(false);
//     }
//   };

 
//     // @param {string} slug - The truck's slug identifier
//     // @returns {object|undefined} - The truck object or undefined if not found
   
//   const getTruckBySlug = (slug) => {
//     if (!slug || trucks.length === 0) return undefined;
//     return trucks.find((truck) => truck.slug === slug);
//   };

//   /**
//    * Get a truck by its ID
//    * @param {string} id - The truck's UUID identifier
//    * @returns {object|undefined} - The truck object or undefined if not found
//    */
//   const getTruckById = (id) => {
//     if (!id || trucks.length === 0) return undefined;
//     return trucks.find((truck) => truck.id === id);
//   };

//   /**
//    * Get trucks filtered by category
//    * @param {string} category - The truck's category (e.g., 'N-Series', 'F-Series')
//    * @returns {array} - Array of trucks matching the category
//    */
//   const getTrucksByCategory = (category) => {
//     if (!category || trucks.length === 0) return [];
//     return trucks.filter((truck) => truck.category === category);
//   };

//   const value = {
//     // State
//     trucks,
//     loading,
//     error,

//     // Helper functions
//     getTruckBySlug,
//     getTruckById,
//     getTrucksByCategory,

//     // Refetch function (in case manual refresh is needed)
//     refetchTrucks: fetchTrucks,
//   };

//   return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
// };

// /**
//  * Custom hook to use the AppContext
//  * @returns {object} - The context value
//  * @throws {Error} - If used outside of AppProvider
//  * 
//  * Usage in components:
//  * const { trucks, loading, error, getTruckBySlug } = useAppContext();
//  */
// export const useAppContext = () => {
//   const context = useContext(AppContext);

//   if (!context) {
//     throw new Error('useAppContext must be used within an AppProvider');
//   }

//   return context;
// };



import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { supabase } from '../shared/supabaseclient';

const AppContext = createContext();

// const CACHE_KEY = 'trucks_cache';
// const META_KEY = 'trucks_meta';
const CHECK_INTERVAL = 1000 * 60 * 10; // 10 minutes
const CACHE_KEY = 'trucks_cache';
const META_KEY = 'trucks_meta';


export const AppProvider = ({ children }) => {
  const [trucks, setTrucks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTrucks();
  }, []);

  



// const logSource = (source) => {
//   console.log(`==============================`);
//   console.log(`🚦 DATA SOURCE: ${source}`);
//   console.log(`==============================`);
// };


const normalizeTime = (t) => {
  if (!t) return null;
  return t.split('.')[0]; // remove microseconds
};

const fetchTrucks = async () => {
  try {
    // console.log("🚀 fetchTrucks triggered");

    setLoading(true);
    setError(null);

    const cached = localStorage.getItem(CACHE_KEY);
    const cachedMeta = localStorage.getItem(META_KEY);

    // console.log("📦 cache exists:", !!cached);
    // console.log("🧠 meta exists:", !!cachedMeta);

    // 🔍 1. ALWAYS check Supabase latest updated_at
    // console.log("🔍 fetching updated_at from Supabase...");

    const { data: metaData, error: metaError } = await supabase
      .from('trucks')
      .select('updated_at')
      .order('updated_at', { ascending: false })
      .limit(1);

    if (metaError) throw metaError;

    const latestUpdatedAtRaw = metaData?.[0]?.updated_at || null;
    const latestUpdatedAt = normalizeTime(latestUpdatedAtRaw);

    // console.log("🕒 latest updated_at:", latestUpdatedAtRaw);

    const cachedMetaParsed = cachedMeta ? JSON.parse(cachedMeta) : null;
    const cachedUpdatedAt = normalizeTime(cachedMetaParsed?.updated_at);

    // console.log("📊 cached updated_at:", cachedUpdatedAt);

    const isChanged = !cachedMetaParsed || cachedUpdatedAt !== latestUpdatedAt;

    // console.log("⚖️ isChanged:", isChanged);

    // 🟢 2. If NOT changed → use cache
    if (cached && !isChanged) {
      // console.log("🟢 USING CACHE (no changes detected)");

      setTrucks(JSON.parse(cached));
      setLoading(false);
      return;
    }

    // 🔥 3. If changed → fetch full data
    // console.log("🔥 FETCHING FULL DATA FROM SUPABASE...");

    const { data, error: supabaseError } = await supabase
      .from('trucks')
      .select('*')
      .order('created_at', { ascending: false });

    if (supabaseError) throw supabaseError;

    setTrucks(data);

    localStorage.setItem(CACHE_KEY, JSON.stringify(data));

    localStorage.setItem(
      META_KEY,
      JSON.stringify({
        updated_at: latestUpdatedAtRaw,
      })
    );

    // console.log("✅ CACHE UPDATED + DATA SET");

  } catch (err) {
    console.error("❌ fetchTrucks error:", err);
    setError(err.message || 'Error fetching trucks');
  } finally {
    setLoading(false);
    // console.log("🏁 fetchTrucks finished");
  }
};
  const getTruckBySlug = (slug) => {
    return trucks.find((truck) => truck.slug === slug);
  };

  const getTruckById = (id) => {
    return trucks.find((truck) => truck.id === id);
  };

  const getTrucksByCategory = (category) => {
    return trucks.filter((truck) => truck.category === category);
  };

  const value = useMemo(() => ({
    trucks,
    loading,
    error,
    getTruckBySlug,
    getTruckById,
    getTrucksByCategory,

    // 🔄 manual refresh (only when needed)
    refetchTrucks: () => fetchTrucks(true),
  }), [trucks, loading, error]);

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

